import React from 'react';
import { T, Lang } from '../lib/i18n';
interface NavProps {
  lang: Lang;
  setLang: (lang: Lang) => void;
}
export function Nav({
  lang,
  setLang
}: NavProps) {
  const t = T[lang].nav;
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <nav className="sticky top-0 z-40 w-full bg-white/95 backdrop-blur-[20px] border-b border-brand-blue-primary/10 shadow-[0_2px_20px_rgba(15,28,63,0.08)] px-4 md:px-8 py-4" data-id="element-268">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-269">
        {/* Logo */}
        <div className="flex-shrink-0 cursor-pointer" onClick={() => scrollTo('inicio')} data-id="element-270">
          <img src="https://cdn.magicpatterns.com/uploads/3197jMv2JiYor9qLBk6q9W/private_openrouter-generated-image-1780958771436.png" alt="Arvex Holding LLC" className="h-10 md:h-12 object-contain" data-id="element-271" />
        </div>

        {/* Center Links (Desktop only) */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-272">
          {[{
          label: t.services,
          id: 'servicios'
        }, {
          label: t.packages,
          id: 'paquetes'
        }, {
          label: t.process,
          id: 'proceso'
        }, {
          label: t.contact,
          id: 'contacto'
        }].map(link => <button key={link.id} onClick={() => scrollTo(link.id)} className="text-brand-text-secondary hover:text-brand-blue-primary font-body text-[0.75rem] font-semibold uppercase tracking-[1.5px] transition-colors" data-id="element-273">
              {link.label}
            </button>)}
        </div>

        {/* Right Actions */}
        <div className="flex items-center space-x-3 md:space-x-4" data-id="element-274">
          <button onClick={() => setLang(lang === 'es' ? 'en' : 'es')} className="bg-white border border-brand-blue-primary/20 text-brand-blue-primary px-3 py-1.5 rounded-full text-xs font-semibold hover:bg-brand-bg-subtle transition-colors flex items-center" data-id="element-275">
            {lang === 'es' ? 'EN 🌐' : 'ES 🌐'}
          </button>

          <button onClick={() => scrollTo('contacto')} className="hidden sm:block bg-gradient-button text-white px-5 py-2.5 rounded-md text-sm font-semibold shadow-[0_4px_15px_rgba(30,95,212,0.3)] hover:shadow-[0_6px_20px_rgba(30,95,212,0.4)] transition-all hover:-translate-y-0.5" data-id="element-276">
            {t.cta}
          </button>
        </div>
      </div>
    </nav>;
}